var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',_vm._g(_vm._b({attrs:{"label":_vm.label,"outlined":_vm.outlined,"accept":_vm.accept,"validate-on-blur":"","show-size":"","dense":""}},'v-file-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }